import React from 'react';
import { VEO_MODELS, formatCost, getModelFeatureBadges } from '../../../services/veoService';

interface VeoModelSelectorProps {
  selectedModel: string;
  onModelChange: (model: string) => void;
}

const VeoModelSelector: React.FC<VeoModelSelectorProps> = ({
  selectedModel,
  onModelChange
}) => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '12px', 
        fontSize: '14px', 
        fontWeight: '500',
        color: '#fff'
      }}>
        🎬 Veo Model:
      </label>
      
      <div style={{ 
        display: 'grid', 
        gap: '12px',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))'
      }}>
        {VEO_MODELS.map((model) => {
          const isSelected = selectedModel === model.id;
          const badges = getModelFeatureBadges(model);
          
          return (
            <div
              key={model.id}
              onClick={() => onModelChange(model.id)}
              style={{
                padding: '16px',
                border: isSelected 
                  ? '2px solid #8b5cf6' 
                  : '1px solid rgba(139, 92, 246, 0.3)',
                borderRadius: '8px',
                backgroundColor: isSelected ? 'rgba(139, 92, 246, 0.1)' : '#1a1a1a',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = '#8b5cf6';
                  e.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.3)';
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                }
              }}
            >
              {/* Model Header */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '8px'
              }}>
                <h4 style={{ 
                  margin: 0, 
                  fontSize: '16px', 
                  fontWeight: 'bold',
                  color: '#fff'
                }}>
                  {model.name}
                </h4>
                <span style={{ 
                  fontSize: '14px', 
                  fontWeight: 'bold',
                  color: '#10b981'
                }}>
                  {/* {formatCost(model.cost)} */}
                </span>
              </div>
              
              {/* Model Description */}
              <p style={{ 
                margin: '0 0 12px 0', 
                fontSize: '13px', 
                color: '#ccc',
                lineHeight: '1.4'
              }}>
                {model.description}
              </p>
              
              {/* Feature Badges */}
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '6px'
              }}>
                {badges.map((badge, index) => (
                  <span
                    key={index}
                    style={{
                      fontSize: '11px',
                      padding: '2px 8px',
                      backgroundColor: model.hasAudio && badge.includes('Audio') 
                        ? '#10b981' 
                        : 'rgba(139, 92, 246, 0.3)',
                      color: '#fff',
                      borderRadius: '12px',
                      fontWeight: '500'
                    }}
                  >
                    {badge}
                  </span>
                ))}
              </div>
              
              {/* Audio Indicator */}
              {model.hasAudio && (
                <div style={{
                  marginTop: '8px',
                  padding: '6px 10px',
                  backgroundColor: 'rgba(16, 185, 129, 0.1)',
                  borderRadius: '6px',
                  border: '1px solid rgba(16, 185, 129, 0.3)'
                }}>
                  <span style={{ 
                    fontSize: '12px', 
                    color: '#10b981',
                    fontWeight: '500'
                  }}>
                    🎵 Native Audio Generation
                  </span>
                </div>
              )}
              
              {/* Selection Indicator */}
              {isSelected && (
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  backgroundColor: '#8b5cf6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span style={{ 
                    color: '#fff', 
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {/* Model Comparison Help */}
      <div style={{
        marginTop: '12px',
        padding: '12px',
        backgroundColor: 'rgba(139, 92, 246, 0.05)',
        borderRadius: '6px',
        border: '1px solid rgba(139, 92, 246, 0.2)'
      }}>
        <p style={{ 
          margin: 0, 
          fontSize: '12px', 
          color: '#ccc',
          lineHeight: '1.4'
        }}>
          💡 <strong>Tip:</strong> Veo 3 models include native audio generation with dialogue, 
          sound effects, and ambient sounds.
          Veo 3 Fast is designed for rapid ideation and prototyping, while Veo 3 offers higher cinematic quality, detail, and realism.
        </p>
      </div>
    </div>
  );
};

export default VeoModelSelector;